import React, { useEffect, useState } from "react";
import { FaHeart, FaStar, FaPhoneAlt, FaEye } from "react-icons/fa";
import girlImage from "../../asset/images/girlimg1.png";
import "./view.css";
import AllProfiles from "../allprofile/allprofile";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Confirm } from "notiflix";
import { useNavigate } from "react-router-dom";
import { Notify } from "notiflix";
export default function ViewProfile() {
  const { id } = useParams();
  const Navigate = useNavigate();
  const [Data, setData] = useState([]);
  const [ProfilePic, setProfilePic] = useState("");
  const [RasiChartData, setRasiChartData] = useState([]);
  const [AmsamChartData, setAmsamChartData] = useState([]);
  const [Reload, setReload] = useState(false);

  const [IntretedStatus, setIntrestedStatus] = useState("");
  const [ShortListStatus, setShortListStatus] = useState("");
  const [MobileNumberStatus, setMobileNumberStatus] = useState("");
  const [matchData, setMatchData] = useState(null);
  const [poruthamStatus, setPoruthamStatus] = useState([]);
  const [loading, setLoading] = useState({ type: null, id: null });
  const isLoading = (type) => loading.type === type && loading.id === id;

  const [RasiChart, setRasiChart] = useState({
    r1: "",
    r2: "",
    r3: "",
    r4: "",
    r5: "",
    r6: "",
    r7: "",
    r8: "",
    r9: "",
    r10: "",
    r11: "",
    r12: "",
  });

  const [AmsamChart, setAmsamChart] = useState({
    a1: "",
    a2: "",
    a3: "",
    a4: "",
    a5: "",
    a6: "",
    a7: "",
    a8: "",
    a9: "",
    a10: "",
    a11: "",
    a12: "",
  });

  const ViewStarMatch = () => {
    const token = JSON.parse(localStorage.getItem("kkm_auth"));
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = {
      viewed_star_match_id: id,
    };
    axios.post(
      "https://kovaikongunadumatrimony.com/kkm_backend/public/api/star-match-porutham",
      data,
      { headers }
    );
    const tamilPoruthamNames = [
      "தினம்",
      "கணம்",
      "யோனி",
      "ராசி",
      "ராசியதிபதி",
      "வசியம்",
      "மஹேந்திரம்",
      "ஸ்திரீதீர்க்கம்",
      "வேத",
      "ராஜஜூ",
      "நாடி",
      "கூடபொருத்தம்",
    ];

    // API Call
    axios
      .post(
        "https://kovaikongunadumatrimony.com/kkm_backend/public/api/star-match-porutham",
        data,
        { headers }
      )
      .then((response) => {
        if (response.data.status === true) {
          const apiData = response.data.data;
          setMatchData(apiData);

          const matched = apiData.porutham.split(",").map(Number);
          const allPorutham = Array.from({ length: 12 }, (_, i) => ({
            number: i + 1,
            matched: matched.includes(i + 1),
          }));

          setPoruthamStatus(allPorutham);
        } else {
          Notify.failure(response.data.message);
        }
      });
  };

  const profile = {
    profile_id: Data.profile_id,
    name: Data.name,
    gender: Data.gender,
    birth_date: Data.birth_date,
    birth_time: Data.birth_time,
    birth_place: Data.birth_place,
    mobile_number:
      MobileNumberStatus == 0
        ? "+" +
          91 +
          " xxxxx" +
          Data.mobile_number?.split("").splice(5, 10).join("")
        : Data.mobile_number,
    alternative_number:
      MobileNumberStatus == 0
        ? "+" +
          91 +
          " xxxxx" +
          Data.alternative_number?.split("").splice(5, 10).join("")
        : Data.alternative_number,
    education: Data.education,
    job_description: Data.job_description,
    work_place: Data.work_place,
    blood_group: Data.blood_group,
    height: Data.height,
    weight: Data.weight,
    color: Data.color,
    monthly_income: Data.monthly_income,
    caste: Data.caste,
    kulam: Data.kulam,
    kula_deivam: Data.kula_deivam,
    age: Data.age,
    jathagam: Data.jathagam,
    star: Data.star,
    rasi: Data.rasi,
    laknam: Data.laknam,
    martial_status: Data.martial_status,
    father_name: Data.father_name,
    mother_name: Data.mother_name,
    expectation: Data.expectation,
    father_job_description: Data.father_job_description,
    mother_job_description: Data.mother_job_description,
    living_place: Data.living_place,
    siblings: Data.siblings,
    property_details: Data.property_details,
  };

  const detailsEntries = Object.entries({
    "Profile ID": profile.profile_id,
    Gender: profile.gender,
    "Marital Status": profile.martial_status,
    Jathagam: profile.jathagam,
    "Birth Date": profile.birth_date,
    "Birth Time": profile.birth_time,
    Age: profile.age,
    "Birth Place": profile.birth_place,
    "Living Place": profile.living_place,
    Education: profile.education,
    Job: profile.job_description,
    "Work Place": profile.work_place,
    "Monthly Income": profile.monthly_income,
    "Blood Group": profile.blood_group,
    Caste: profile.caste,
    Kulam: profile.kulam,
    Kuladeivam: profile.kula_deivam,
    Color: profile.color,
    Height: profile.height,
    Weight: profile.weight,
    Star: profile.star,
    Rasi: profile.rasi,
    Laknam: profile.laknam ?? "-",
    "Father Name": profile.father_name,
    "Father Job": profile.father_job_description,
    "Mother Name": profile.mother_name,
    "Mother Job": profile.mother_job_description,
    Siblings: profile.siblings,
    Expectation: profile.expectation,
    Property: profile.property_details,
    "Mobile Number": profile.mobile_number,
    "Alternative Number": profile.alternative_number,
});

  const half = Math.ceil(detailsEntries.length / 2);
  const firstHalf = detailsEntries.slice(0, half);
  const secondHalf = detailsEntries.slice(half);

  useEffect(() => {
    const token = JSON.parse(localStorage.getItem("kkm_auth"));
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = {
      profile_id: id,
    };
    axios
      .post(
        "https://kovaikongunadumatrimony.com/kkm_backend/public/api/click-profile",
        data,
        { headers }
      )
      .then((response) => {
        if (response.data.status === true) {
          setData(response.data.profile_data);
          setProfilePic(response.data.profile_data.profile_photo_1);
          let rasidata = response.data.rasi_chart;
          let amsamData = response.data.amsam_chart;
          setIntrestedStatus(response.data.profile_data.intrest_status);
          setShortListStatus(response.data.profile_data.short_list_status);
          setMobileNumberStatus(
            response.data.profile_data.mobile_number_status
          );
          setRasiChart({
            r1: rasidata.r1,
            r2: rasidata.r2,
            r3: rasidata.r3,
            r4: rasidata.r4,
            r5: rasidata.r5,
            r6: rasidata.r6,
            r7: rasidata.r7,
            r8: rasidata.r8,
            r9: rasidata.r9,
            r10: rasidata.r10,
            r11: rasidata.r11,
            r12: rasidata.r12,
          });
          setAmsamChart({
            a1: amsamData.a1,
            a2: amsamData.a2,
            a3: amsamData.a3,
            a4: amsamData.a4,
            a5: amsamData.a5,
            a6: amsamData.a6,
            a7: amsamData.a7,
            a8: amsamData.a8,
            a9: amsamData.a9,
            a10: amsamData.a10,
            a11: amsamData.a11,
            a12: amsamData.a12,
          });
          setRasiChartData(response.data.rasi_chart);
          setAmsamChartData(response.data.amsam_chart);
        } else {
          Notify.failure(response.data.message);
        }
      });
  }, [Reload]);

  const AddIntrest = (id) => {
    setLoading({ type: "interest", id });

    const token = JSON.parse(localStorage.getItem("kkm_auth"));
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = {
      RequestedId: id,
    };
    axios
      .post(
        "https://kovaikongunadumatrimony.com/kkm_backend/public/api/send-interested",
        data,
        { headers }
      )
      .then((response) => {
        if (response.data.status === true) {
          Notify.success(response.data.message);
          setReload((pre) => !pre);
        } else {
          Notify.failure(response.data.message);
          setReload((pre) => !pre);
        }
      })
      .finally(() => setLoading({ type: null, id: null }));
  };
  const RemoveIntrest = (id) => {
    setLoading({ type: "interest", id });

    const token = JSON.parse(localStorage.getItem("kkm_auth"));
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = {
      RequestedId: id,
    };
    axios
      .post(
        "https://kovaikongunadumatrimony.com/kkm_backend/public/api/remove-interested",
        data,
        { headers }
      )
      .then((response) => {
        if (response.data.status === true) {
          setReload((data) => !data);
          Notify.success(response.data.message);
          // setReload((pre) => !pre);
        } else {
          Notify.failure(response.data.message);
          // setReload((pre) => !pre);
        }
      })
      .finally(() => setLoading({ type: null, id: null }));
  };

  const AddShortList = (id) => {
    setLoading({ type: "shortlist", id });

    const token = JSON.parse(localStorage.getItem("kkm_auth"));

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = {
      RequestedId: id,
    };

    axios
      .post(
        "https://kovaikongunadumatrimony.com/kkm_backend/public/api/short-list-profile",
        data,
        { headers }
      )
      .then((response) => {
        if (response.data.status === true) {
          Notify.success(response.data.message);
          setReload((pre) => !pre);
        } else {
          Notify.failure(response.data.message);
          setReload((pre) => !pre);
        }
      })
      .finally(() => setLoading({ type: null, id: null }));
  };
  const RemoveShortList = (id) => {
    setLoading({ type: "shortlist", id });

    const token = JSON.parse(localStorage.getItem("kkm_auth"));
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = {
      RequestedId: id,
    };

    axios
      .post(
        "https://kovaikongunadumatrimony.com/kkm_backend/public/api/remove-short-list-profile",
        data,
        { headers }
      )
      .then((response) => {
        if (response.data.status === true) {
          Notify.success(response.data.message);
          setReload((pre) => !pre);
        } else {
          Notify.failure(response.data.message);
          setReload((pre) => !pre);
        }
      })
      .finally(() => setLoading({ type: null, id: null }));
  };
  const HandlePurchaseMobileNumber = (id) => {
    Confirm.show(
      "Purchase Mobile Number",
      "Are you sure you want to purchase this profile? This will deduct 1 point from your wallet.",
      "Yes, Purchase",
      "Cancel",
      () => {
        setLoading({ type: "purchase", id });

        const token = JSON.parse(localStorage.getItem("kkm_auth"));
        const headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        };
        const data = {
          RequestedId: id,
        };

        axios
          .post(
            "https://kovaikongunadumatrimony.com/kkm_backend/public/api/purchase-mobile-number",
            data,
            { headers }
          )
          .then((response) => {
            if (response.data.status === true) {
              Notify.success(response.data.message);
              setReload((pre) => !pre);
              Navigate("/purchased-profiles");
            } else {
              Notify.failure(response.data.message);
              setReload((pre) => !pre);
            }
          })
          .finally(() => setLoading({ type: null, id: null }));
      },
      () => {},
      {}
    );
  };
  const HandleDownloadBiodata = () => {
    Navigate(`/bio-data/${id}`);
  };

  const WaveLoader = () => (
    <span className="wave-loader" aria-label="loading">
      <span></span>
      <span></span>
      <span></span>
    </span>
  );

  const renderTable = (chart, chartName) => (
    <table className="birth-table-2 m-auto" cellSpacing="0" cellPadding="0">
      <tbody>
        <tr>
          <td className="kattam-text">{chart[chartName + "12"]}</td>
          <td className="kattam-text">{chart[chartName + "1"]}</td>
          <td className="kattam-text">{chart[chartName + "2"]}</td>
          <td className="kattam-text">{chart[chartName + "3"]}</td>
        </tr>
        <tr>
          <td className="kattam-text">{chart[chartName + "11"]}</td>
          <td
            className="view-chart-birth text-center"
            width="220"
            height="220"
            colSpan="2"
            rowSpan="2"
          >
            <p className="rasi-chart">
              {chartName === "r" ? "ராசி" : "நவாம்சம்"}
            </p>
          </td>
          <td className="kattam-text">{chart[chartName + "4"]}</td>
        </tr>
        <tr>
          <td className="kattam-text">{chart[chartName + "10"]}</td>
          <td className="kattam-text">{chart[chartName + "5"]}</td>
        </tr>
        <tr>
          <td className="kattam-text">{chart[chartName + "9"]}</td>
          <td className="kattam-text">{chart[chartName + "8"]}</td>
          <td className="kattam-text">{chart[chartName + "7"]}</td>
          <td className="kattam-text">{chart[chartName + "6"]}</td>
        </tr>
      </tbody>
    </table>
  );

  return (
    <>
      <div className="top-card mt-4">
        {/* Left Side - Image */}
        <div className="image-section">
          <img
            src={`https://kovaikongunadumatrimony.com/kkm_admin/public/assets/prof_images/${Data.profile_photo_1}`}
            alt={profile.name}
          />
        </div>

        {/* Right Side - Content */}
        <div className="right-section">
          <h2 className="profile-name">{profile.name}</h2>

          <div className="button-group">
            <div className="top-buttons">
              {/* Interest */}
              {IntretedStatus == 0 ? (
                <button
                  className="button interest"
                  onClick={() => AddIntrest(id)}
                  disabled={isLoading("interest")}
                >
                  {isLoading("interest") ? (
                    <WaveLoader />
                  ) : (
                    <>
                      <FaHeart className="btn-icon" /> Interest
                    </>
                  )}
                </button>
              ) : (
                <button
                  className="button interested"
                  onClick={() => RemoveIntrest(id)}
                  disabled={isLoading("interest")}
                >
                  {isLoading("interest") ? (
                    <WaveLoader />
                  ) : (
                    <>
                      <FaHeart className="btn-icon" /> Interested
                    </>
                  )}
                </button>
              )}

              {/* Shortlist */}
              {ShortListStatus == 0 ? (
                <button
                  className="button shortlist"
                  onClick={() => AddShortList(id)}
                  disabled={isLoading("shortlist")}
                >
                  {isLoading("shortlist") ? (
                    <WaveLoader />
                  ) : (
                    <>
                      <FaStar className="btn-icon" /> Shortlist
                    </>
                  )}
                </button>
              ) : (
                <button
                  className="button shortlisted"
                  onClick={() => RemoveShortList(id)}
                  disabled={isLoading("shortlist")}
                >
                  {isLoading("shortlist") ? (
                    <WaveLoader />
                  ) : (
                    <>
                      <FaStar className="btn-icon" /> Shortlisted
                    </>
                  )}
                </button>
              )}

              {/* Purchase Contact */}
              {MobileNumberStatus == 0 ? (
                <button
                  className="button purchaseno"
                  onClick={() => HandlePurchaseMobileNumber(id)}
                  disabled={isLoading("purchase")}
                >
                  {isLoading("purchase") ? (
                    <WaveLoader />
                  ) : (
                    <>
                      <FaPhoneAlt className="btn-icon" /> Purchase Contact
                    </>
                  )}
                </button>
              ) : (
                <button className="button purchasedno">
                  <FaPhoneAlt className="btn-icon" /> Contact Purchased
                </button>
              )}
            </div>

            <div className="bottom-buttons">
              <button
                className="button horoscope"
                onClick={HandleDownloadBiodata}
              >
                <FaEye className="btn-icon" /> View Horoscope
              </button>
              <button className="button starmatch" onClick={ViewStarMatch}>
                <FaEye className="btn-icon" /> View Star Match
              </button>
            </div>
          </div>
        </div>
      </div>

      {matchData && (
        <div className="porutham-card">
          <div className="porutham-header">
            <h3>
              {matchData.my_name} &amp; {matchData.partner_name}
            </h3>
          </div>
          <div className="porutham-body">
            <p>
              <strong>My Rasi:</strong>{" "}
              <span>
                {matchData.my_rasi} ({matchData.my_star})
              </span>
              <br />
              <strong>Partner Rasi:</strong>{" "}
              <span>
                {matchData.partner_Rasi} ({matchData.partner_star})
              </span>
            </p>
            <h4 className="porutham-result">
              Porutham Result: {matchData.result}
            </h4>

            <ul className="porutham-list">
              {[
                "கண",
                "தின",
                "யோனி",
                "ராசி",
                "ரஜ்ஜு",
                "வேத",
                "வசிய",
                "மகேந்திர",
                "ஸ்திரீரீதிய",
                "நாடி",
                "கிரஹ",
                "சீல",
              ].map((name, idx) => (
                <li
                  key={idx}
                  className={
                    poruthamStatus[idx]?.matched ? "matched" : "not-matched"
                  }
                >
                  {name} {" "}
                  {poruthamStatus[idx]?.matched
                    ? "பொருத்தம் உள்ளது ✔"
                    : "பொருத்தம் இல்லை ✘"}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}

      <div className="details-card">
        <h3 className="profile-name-head">Profile Details</h3>
        <div className="details-table-wrapper">
          <table className="details-table">
            <tbody>
              {firstHalf.map(([label, value]) => (
                <tr key={label}>
                  <td className="label">{label}</td>
                  <td className="colon">:</td>
                  <td className="value">{value}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <table className="details-table">
            <tbody>
              {secondHalf.map(([label, value]) => (
                <tr key={label}>
                  <td className="label">{label}</td>
                  <td className="colon-1">:</td>
                  <td className="value">
  {(() => {
    if (!value) return null;
    const words = value.split(" ");
    const firstLine = words.slice(0, 3).join(" ");
    const rest = words.slice(3).join(" ");
    return (
      <>
        {firstLine}
        {rest && <><br />{rest}</>}
      </>
    );
  })()}
</td>

                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      

      <div className="kattam-container">
        <h3 className="profile-name-head">Jathaga Kattam</h3>
        <div className="kattam-table-wrapper">
          {renderTable(RasiChart, "r")}
          {renderTable(AmsamChart, "a")}
        </div>
      </div>
    </>
  );
}
